import { ChangePackageStatus } from '@/features/dashboard/bookingChanges/types/ChangeViewModel.ts';
import { getChangeEditLockReason } from '@/features/dashboard/bookingChanges/types/ChangeViewModel.utils.ts';

/**
 * Czy ekran wpuszcza w tryb edycji, a jeśli nie — dlaczego.
 *
 * Powód wędruje w dwa miejsca naraz: `title` wyłączonego przełącznika trybu
 * i belka szkicu pod zakładkami. Trzymamy go w jednym obiekcie, żeby oba
 * miejsca nie mogły powiedzieć czegoś innego.
 */
export interface ChangeEditAvailabilityVm {
  canEdit: boolean;
  /** Zdanie tłumaczące blokadę; puste, gdy edycja jest wolna. */
  reason?: string;
}

const EDITABLE: ChangeEditAvailabilityVm = { canEdit: true };

/**
 * Brak paczki (`null`) znaczy „nie ma otwartego szkicu” — wejście w tryb
 * edycji dopiero go założy, więc jest dozwolone.
 */
export const resolveEditAvailability = (
  status: ChangePackageStatus | null | undefined,
): ChangeEditAvailabilityVm => {
  if (!status) {
    return EDITABLE;
  }

  const reason = getChangeEditLockReason(status);

  return reason ? { canEdit: false, reason } : EDITABLE;
};
